import { useContext, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Grid } from '@mui/material';
import useAdminAPI from 'src/services/useAdminAPI';
import AdminAuthContext from 'src/store/admin-auth-context';
import ToastContext from 'src/store/toast-context';
import Logo from 'src/components/Logo';
import LoginFormCard from 'src/components/LoginFormCard';
import LoginForm from 'src/components/LoginForm';
import Footer from 'src/components/layout/Footer';
import 'src/styles/Login.scss';
import { useLoaded } from 'src/store/load-context';
import { useEffect } from 'react';
import { stringValidation } from 'src/services/validation';
import MuiValidTextField from 'src/components/input/MuiValidTextField';

import * as Yup from 'yup';
const loginSchema = Yup.object().shape({
  username: stringValidation(),
  password: stringValidation(),
});

const initialValues = {
  username: '',
  password: '',
};
const AdminLoginPage = () => {
  const api = useAdminAPI();
  const auth = useContext(AdminAuthContext);
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const { handleError, error } = useContext(ToastContext);
  const { setLoaded } = useLoaded();
  let redirectPath = new URLSearchParams(history.location.search).get('redirect') ?? '/admin';

  useEffect(() => {
    setLoaded(true);
  }, [setLoaded]);

  const login = async ({ username, password }) => {
    try {
      setSubmitting(true);
      await api.post('/admin/login', { username, password });
      let response = await api.post('/admin/accessToken', { username, password });
      auth.login(response.headers['x-access-token'], response.data.exp);
      history.replace(redirectPath);
    } catch (err) {
      if (err.response?.status === 400) error('Invalid username or password');
      else {
        handleError(err);
      }
    }
    setSubmitting(false);
  };

  if (auth.isLoggedIn) {
    return <Redirect to="/admin/home" />;
  }

  return (
    <>
      <Grid
        className="main-container"
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', gap: '2rem' }}
      >
        <header style={{ marginTop: '2rem' }}>
          <Logo />
        </header>
        <Grid
          sx={{
            spacing: '0.25rem',
            my: '0.125rem',
            flexDirection: 'column',
            justify: 'center',
            width: '21rem',
          }}
        >
          <LoginFormCard title={'Personal Property Admin Portal Login'}>
            <LoginForm
              onSubmit={login}
              loaded={!submitting}
              initialValues={initialValues}
              schema={loginSchema}
              fields={[
                {
                  name: 'username',
                  component: MuiValidTextField,
                  label: 'Username',
                  variant: 'standard',
                  'data-cy': 'username',
                },
                {
                  name: 'password',
                  component: MuiValidTextField,
                  label: 'Password',
                  variant: 'standard',
                  type: 'password',
                  'data-cy': 'password',
                },
              ]}
            />
          </LoginFormCard>
        </Grid>
        <Footer />
      </Grid>
    </>
  );
};

export default AdminLoginPage;
